<template>
    <div class="components-navbar">
        <div class="navbar-carrier">
            <div class="navbar-content">
                <div class="navbar-logo" @click="toIndex">
                    <div class="logo"></div>
                </div>
                <div class="site-navigate">
                    <el-popover placement="bottom" width="480" trigger="click">
                        <span class="el-dropdown-link" slot="reference">
                            {{ substationName }}
                            <i class="el-icon-arrow-down el-icon--right"></i>
                        </span>
                        <div class="popover-content">
                            <div class="title">甘肃分站</div>
                            <el-link
                                :underline="false"
                                type="info"
                                @click="toIndex"
                                >甘肃站 ></el-link
                            >

                            <div class="sub-content">
                                <div
                                    v-for="station in substationList"
                                    :key="station.id"
                                >
                                    <div
                                        class="city-item"
                                        @click="setCurrentStation(station)"
                                        :class="{ city: !station.parentPath }"
                                    >
                                        {{ station.name }} >
                                    </div>
                                    <div class="station-child">
                                        <div
                                            v-for="child in station.children"
                                            :key="child.id"
                                            @click="setCurrentStation(child)"
                                            class="city-item"
                                        >
                                            {{ child.name }}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </el-popover>
                </div>
            </div>
            <div class="navbar-menu">
                <el-menu
                    :default-active="route"
                    class="el-menu"
                    mode="horizontal"
                    router
                    menu-trigger="hover"
                    background-color="transition"
                    text-color="#fff"
                    active-text-color="#fff"
                    ref="navbarMenuRef"
                >
                    <template
                        v-for="(menuItem, menuItemIndex) in menuItemArray"
                    >
                        <template v-if="menuItem.children.length !== 0">
                            <el-submenu
                                :index="`${menuItemIndex}`"
                                :key="'el-menu-item' + menuItemIndex"
                            >
                                <template slot="title">{{
                                    menuItem.label
                                }}</template>
                                <template
                                    v-for="(
                                        children, childrenIndex
                                    ) in menuItem.children"
                                >
                                    <el-menu-item
                                        :index="`${children.activeIndex}`"
                                        :key="'el-menu-item' + childrenIndex"
                                        >{{ children.label }}</el-menu-item
                                    >
                                </template>
                            </el-submenu>
                        </template>
                        <template v-else>
                            <el-menu-item
                                :index="`${menuItem.activeIndex}`"
                                :key="'el-menu-item' + menuItemIndex"
                            >
                                {{ menuItem.label }}
                            </el-menu-item>
                        </template>
                    </template>
                    <el-menu-item>
                        <template v-if="!isLogin">
                            <el-button
                                type="primary"
                                size="small"
                                round
                                @click="userLogin"
                                >登录</el-button
                            >
                        </template>
                        <template v-else>
                            <el-dropdown
                                @command="handleCommand"
                                trigger="click"
                            >
                                <span class="el-dropdown-link">
                                    <div
                                        class="portrait"
                                        @click.stop="authentication"
                                    >
                                        <div
                                            class="portrait-tag"
                                            v-if="
                                                $store.getters.userSourceType ==
                                                '7'
                                            "
                                        >
                                            {{
                                                authenticationText[
                                                    certiFlg || 1
                                                ]
                                            }}
                                        </div>
                                    </div>
                                    <!-- {{ userName }} -->
                                    <i
                                        class="el-icon-arrow-down el-icon--right"
                                    ></i>
                                </span>
                                <el-dropdown-menu slot="dropdown">
                                    <el-dropdown-item command="adminCenter"
                                        >管理后台</el-dropdown-item
                                    >

                                    <el-dropdown-item command="personalCenter"
                                        >个人中心</el-dropdown-item
                                    >
                                    <el-dropdown-item command="information"
                                        >消息中心</el-dropdown-item
                                    >
                                    <el-dropdown-item command="exitLogin"
                                        >退出登录</el-dropdown-item
                                    >
                                </el-dropdown-menu>
                            </el-dropdown>
                        </template>
                    </el-menu-item>
                </el-menu>
            </div>
        </div>
    </div>
</template>
<script>
import { getProviceAll } from "@/common.js";
import { isParamEmpty } from "@/filters";
import { substationList } from "@/assets/json/data";
import { mapGetters } from "vuex";
export default {
    name: "ComponentsNavbar",
    props: {
        userName: {
            type: String,
            default: () => {
                return "";
            },
            required: true,
        },
        isLogin: {
            type: Boolean,
            default: () => {
                return false;
            },
            required: true,
        },
    },
    data() {
        return {
            logoSrc: require("@/assets/logo.png"),
            logo2Src: require("@/assets/logo2.png"),
            menuItemArray: [
                { label: "首页", activeIndex: "/index", children: [] },
                { label: "金融超市", activeIndex: "/financial", children: [] },
                {
                    label: "特色专区",
                    activeIndex: "/characteristicArea",
                    children: [],
                },
                {
                    label: "项目信息",
                    activeIndex: "/projectInfo",
                    children: [],
                },
                {
                    label: "首贷中心",
                    activeIndex: "/loan",
                    children: [],
                },
                {
                    label: "信用服务",
                    activeIndex: "/serveHall",
                    children: [],
                },
                {
                    label: "政策速递",
                    activeIndex: "/policy",
                    children: [],
                },
            ],
            siteRegionDefault: { regionName: "甘肃省", regionCode: "620000" },
            substationName: "甘肃站",
            substationList,
            authenticationText: {
                1: "未认证",
                2: "认证中",
                3: "认证通过",
                4: "认证失败",
            },
        };
    },
    watch: {
        certiFlg: {
            handler(val) {
                console.log(val);
            },
            immediate: true,
            deep: true,
        },
    },
    created() {
        this.substationName =
            (this.currSubstation && this.currSubstation.name) || "甘肃站";
    },
    mounted() {},
    computed: {
        ...mapGetters(["currSubstation", "certiFlg"]),
        route() {
            const route = this.$route;
            const { meta, path } = route;
            // 可以在路由配置文件中设置自定义的路由路径到meta.activeMenu属性中，来控制菜单自定义高亮显示
            // meta中 有activeMenu 字段的子页面，都会显示高亮
            if (meta.activeMenu) {
                return `/${meta.activeMenu}`;
            }
            return path;
        },
    },
    methods: {
        setCurrentStation(val) {
            console.log(val);
            let path = val.parentPath
                ? val.parentPath + "/" + val.path
                : val.path;
            window.location.href = "/" + path + this.$route.path;
        },
        toIndex() {
            window.location.href = "/";
        },
        siteChange(command) {
            if (command.openUrl) {
                window.open(command.openUrl, "_blank");
            } else {
                location.reload();
            }
        },
        visibleChange(val) {
            this.$emit("visibleChange", val);
        },
        userLogin() {
            this.$emit("userLogin");
        },
        handleCommand(val) {
            this.$emit("handleCommand", val);
        },
        authentication() {
            if (['7','17'].includes(this.$store.getters.userSourceType) ||this.$store.getters.userSourceType == "17" || this.$store.getters.userSourceType == null) {
                if (['1', '4'].includes(this.certiFlg)||this.certiFlg== null) {
                    this.$router.push({ path: "/authentication" });
                } else if (this.certiFlg == 3) {
                    window.location.href = this.$store.getters.protalUrl + "/";
                }
            } else {
                window.location.href = this.$store.getters.protalUrl + "/";
            }
        },
    },
};
</script>

<style lang="scss" scoped>
@font-face {
    font-family: "JXCK";
    src: url("/static/tff/JXCK.ttf");
    font-weight: normal;
    font-style: normal;
}

.components-navbar {
    position: fixed;
    padding: 0 50px;
    top: 0;
    right: 0;
    left: 0;
    height: 85px;
    z-index: 999;
    background-color: transparent;

    .navbar-logo .el-image {
        margin: 18px 0;

    }

    & > .el-col {
        height: 85px;
    }

    >>> .el-image {
        overflow: inherit;
        display: inherit;

        .el-image__inner {
            // width: 50px;
            height: 50px;
        }
    }

    .el-image::after {
        content: "";
        color: white;
        position: absolute;
        font-size: 26px;
        left: 60px;
        top: 10px;
        font-family: JXCK;
    }

    .navbar-carrier {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        height: 100%;

        .navbar-content {
            // width: 710px;
            display: flex;
            justify-content: center;
            align-items: center;
            padding-left: 50px;
        }

        .navbar-logo {
            // width: 560px;
            width: 370px;
            height: 50px;
            cursor: pointer;
            .logo {
                // width: 100%;
                height: 50px;
                background: url("./../assets/logo.png") no-repeat;
                background-size: auto 100%;
                background-position: center;
                background-repeat: no-repeat;
                height: 100%;
                /* 元素高度设置为100% */
            }
        }

        .site-navigate {
            width: 150px;
            text-align: center;

            .el-dropdown-link {
                font-size: 18px;
                color: #fff;
                font-weight: bold;
            }

            .el-dropdown {
                cursor: pointer;
            }
        }

        .navbar-menu {
            position: relative;
            top: 0;
            height: 85px;
            line-height: 85px;
            .el-dropdown-link {
                height: 60px;
                display: flex;
                align-items: center;
                margin-top: 12px;
                .portrait {
                    width: 60px;
                    height: 60px;
                    background: #0e73db url(../assets/xyd/portrait.png)
                        no-repeat center center;
                    background-size: 40px 40px;
                    display: inline-block;

                    border-radius: 50%;
                    position: relative;
                    .portrait-tag {
                        height: 16px;
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        font-size: 12px;
                        background: #fe9b00;
                        color: #fff;
                        width: 60px;
                        line-height: 16px;
                        text-align: center;
                    }
                }
                .el-icon-arrow-down {
                }
            }
        }
    }
}

.el-popover {
    .popover-content {
        padding: 0 10px;
        .title {
            font-size: 16px;
            color: #666;
            border-bottom: 1px solid #d5dde5;
            padding-bottom: 12px;
            display: flex;
            justify-content: space-between;
        }
        .el-link {
            margin-top: 10px;
            margin-right: 30px;
            color: #333;
            font-weight: 400;
        }
        .sub-content {
            & > div {
                display: flex;
                .city-item {
                    font-size: 14px;
                    font-weight: 400;
                    color: #666;
                    cursor: pointer;
                    padding: 4px 16px 4px 0;
                    &:hover {
                        color: #0e73db;
                    }
                }
                .city {
                    color: #333;
                    margin-right: 8px;
                }
                .station-child {
                    display: flex;
                    flex-wrap: wrap;
                    flex: 1;
                }
            }
        }
    }
}
</style>


<style lang="scss">
.components-navbar {
    .el-menu {
        li > .el-dropdown {
            color: #fff !important;
            font-size: 16px !important;
            font-weight: bold;
        }
        .el-menu-item {
            font-weight: bold !important;
            padding: 0 5px;
        }

        .el-menu-item i {
            color: #fff !important;
        }

        .el-menu-item:last-child {
            .el-dropdown-selfdefine {
                font-size: 18px;
            }

            & * {
                vertical-align: inherit;
            }
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/Navbar.vue